module.exports = "<div id=\"timeSeriesGraph\" #timeSeriesGraph style=\"width: 100%; height: 100%;\"></div>"